import { render, staticRenderFns } from "./product.vue?vue&type=template&id=052e0c80&scoped=true"
import script from "./product.vue?vue&type=script&lang=js"
export * from "./product.vue?vue&type=script&lang=js"
import style0 from "./product.vue?vue&type=style&index=0&id=052e0c80&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052e0c80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('052e0c80')) {
      api.createRecord('052e0c80', component.options)
    } else {
      api.reload('052e0c80', component.options)
    }
    module.hot.accept("./product.vue?vue&type=template&id=052e0c80&scoped=true", function () {
      api.rerender('052e0c80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/frontPageManage/configureManage/mobilePreview/components/product.vue"
export default component.exports